import React, { useEffect, useState } from "react";
import { Outlet} from "react-router-dom";

import { Box, CssBaseline, Grid } from "@mui/material";

import PrivateHeaderComponent from "./components/private-header/private-header.component";
import { useLocation } from "react-router-dom";
import IUserDetails from "../shared/contracts/IUserDetails";
import useHelpers from "../shared/services/helpers/useHelpers.hook";
import useAppStoreContext from "../shared/context/app-store/app-store.context";
import ToastProvider from "../shared/context/toast/toast-context";

interface IProps { }
function PrivatePage({ }: IProps) {
  const { getCookie } = useHelpers();
  const {
    userNameGlobally, setUserNameGlobally, userIdGlobally,
    setUserIdGlobally, cacheAccessToken,
    tenantCode, setTenantCode, userTenants, setUserTenants,
  } = useAppStoreContext();

  const search = useLocation().search;
  const tcd = new URLSearchParams(search).get("tcd");
  const userName = new URLSearchParams(search).get("username") || "";
  const encodedToken = new URLSearchParams(search).get("oktaAccessToken");

  // Pass the route parameter to the hook
  useEffect(() => {
    if (userName && userName != "" && userName != "{}") {
      setUserNameGlobally(userName);
    }
  }, [userName]);

  useEffect(() => {
    if (tcd && tcd != "") {
      setTenantCode(tcd);
      //const accessToken = getCookie("oktaAccessToken");
      if (encodedToken) {
        // Decode the Base64 token
        const decodedToken = atob(encodedToken);
        console.log("Retrieved Token:", decodedToken);
        cacheAccessToken(decodedToken);
      } else {
        console.error("No access token found");
      }
    }
  }, [tcd, getCookie, cacheAccessToken]);

  const [userData, setUserData] = useState<IUserDetails | null>(null);
  const IDENTITY_BASE_URL: string = `${process.env.REACT_APP_ENTRA_IDENTITY_URL}`;


  //TODO : need to revisit and call useApi methods instead
  useEffect(() => {
    if (userNameGlobally) {
      fetch(`${IDENTITY_BASE_URL}/User/${userNameGlobally}`)
        .then((response) => response.json())
        .then((userData) => setUserData(userData))
        .catch((error) => console.error(error));
    }
  }, [userNameGlobally]);

  useEffect(() => {
    if (userData?.userID && userData.userID != null) {
      setUserIdGlobally(userData.userID);
    }
  }, [userData?.userID]);

  useEffect(() => {
    if (userData?.userID && userData.userID != null) {
      fetch(`${IDENTITY_BASE_URL}/User/UserTenants/${userData?.userID}`)
        .then((response) => response.json())
        .then((userTenants) => setUserTenants(userTenants))
        .catch((error) => console.error(error));
    }
  }, [userIdGlobally]);

  const matchedTenant = userTenants.map((item) =>
    item.tenantCode === tenantCode
      ? item.tenantName
      : alert("invalid tenant for the user")
  )[0];
  return (
    <ToastProvider>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />

        <Grid container direction="column">
          {/* sideNav-section */}

          {/* Header */}
          <PrivateHeaderComponent
            headerUserName={userNameGlobally}
            headerTenantName={matchedTenant!}
          />

          {/* content-section */}
          <Outlet />

          {/* footer-section */}
        </Grid>
        {/* } */}
      </Box>
    </ToastProvider>
  );
}
export default PrivatePage;
